import SustainabilityTeamImage from '@g17eco/images/sustainability_team.png';
import { CollapseButton, CollapseContent, CollapsePanel } from '@g17eco/molecules/collapse-panel';
import { DashboardSection } from '@g17eco/molecules/dashboard';
import { Button } from 'reactstrap';

const faq: { question: string; answer: string }[] = [
  {
    question: 'What do I need to look for?',
    answer:
      'Firstly, when looking for a carbon calculator, make sure that emissions have relevant auditable emission factors for your company’s locations/ facilities and industries down to the product level.',
  },
  {
    question: 'What methodology should it follow?',
    answer:
      'A calculator should be based on robust science and data for your relevant industry. Ensure that the platform’s methodology is aligned to GHG protocol and supports your ability to make Science Based Targets.',
  },
  {
    question: 'What about functionality?',
    answer:
      'Ideally, you want a platform that Instantly generates dashboards and reports for relevant metrics and Scopes. It should also be supported by climate experts to help check and verify the output. An easy onboarding process is a bonus.',
  },
  {
    question: 'Spend or Activity based calculations?',
    answer: 'Both! It’s best if the platform can make use of both methods to calculate your company’s footprint.',
  },
  {
    question: 'Any practicalities to consider?',
    answer:
      'When looking for a carbon calculator, you should make sure that the platform allows delegation to multiple users - those inside your company plus external users such as third-party contractors. Also, it the offer aligned to your company’s budget and reporting schedule?',
  },
];

export const EmissionsCalculatorSidebar = ({ toggleRequestDemoModal }: { toggleRequestDemoModal: () => void }) => {
  return (
    <DashboardSection padding={0} className='calculator-sidebar'>
      <div className='px-3'>
        <div className='text-center text-xl text-ThemeTextDark'>How to select a carbon calculator</div>
        <div className='text-center'>Everything you need to know</div>
      </div>
      <div className='mt-3'>
        {faq.map((qa, i) => (
          <CollapsePanel key={`cp-${qa.question}-${i}`} className='mt-2' collapsed={i !== 0}>
            <CollapseButton>
              <span className='text-ThemeTextMedium strong'>{qa.question}</span>
            </CollapseButton>
            <CollapseContent className='mt-2 ps-5'>
              <>{qa.answer}</>
            </CollapseContent>
          </CollapsePanel>
        ))}
      </div>
      <div className='mt-3 p-4 text-center background-ThemeBgDarkest text-ThemeTextWhite'>
        <div>
          <img src={SustainabilityTeamImage} alt='Sustainability team' />
        </div>
        <div className='text-lg'>Still have questions?</div>
        <div className='mt-2'>Can't find the answer you're look for? Please chat to our friendly team.</div>
        <div className='mt-3'>
          <Button color='secondary' size='lg' onClick={toggleRequestDemoModal}>
            Get in touch
          </Button>
        </div>
      </div>
    </DashboardSection>
  );
};
